"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DELETE_COMMENTS_FORM = exports.DELETE_EMAIL_TYPE = exports.DELETE_PROPERTY = exports.DELETE_LISTS = exports.DELETE_EMAILS = exports.DELETE_FORM = exports.BLOG_NAME_CONFIRMATION = void 0;

var _SimpleStagedObject = _interopRequireDefault(require("redux-less/SimpleStagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var BLOG_NAME_CONFIRMATION = 'blogNameConfirmation';
exports.BLOG_NAME_CONFIRMATION = BLOG_NAME_CONFIRMATION;
var DELETE_FORM = 'deleteForm';
exports.DELETE_FORM = DELETE_FORM;
var DELETE_EMAILS = 'deleteEmails';
exports.DELETE_EMAILS = DELETE_EMAILS;
var DELETE_LISTS = 'deleteLists';
exports.DELETE_LISTS = DELETE_LISTS;
var DELETE_PROPERTY = 'deleteProperty';
exports.DELETE_PROPERTY = DELETE_PROPERTY;
var DELETE_EMAIL_TYPE = 'deleteEmailType';
exports.DELETE_EMAIL_TYPE = DELETE_EMAIL_TYPE;
var DELETE_COMMENTS_FORM = 'deleteCommentsForm';
exports.DELETE_COMMENTS_FORM = DELETE_COMMENTS_FORM;
var DELETE_BLOG = 'DeleteBlog';
var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: BLOG_NAME_CONFIRMATION,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: DELETE_FORM,
  initialValue: true
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: DELETE_EMAILS,
  initialValue: true
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: DELETE_LISTS,
  initialValue: true
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: DELETE_PROPERTY,
  initialValue: true
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: DELETE_EMAIL_TYPE,
  initialValue: true
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: DELETE_COMMENTS_FORM,
  initialValue: true
}];
var DeleteBlog = new _SimpleStagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.website.blogs.staging.deleteBlog;
  },
  properties: properties,
  objectType: DELETE_BLOG,
  namespace: 'blogs'
});
var _default = DeleteBlog;
exports.default = _default;